import { PeopleDocument } from "@/features/people/graphql/generated";
import {
  TeamDocument,
  useRemovePersonFromTeamMutation,
} from "@/features/teams/graphql/generated";
import { DimensionsDocument } from "@/shared/services/api/graphql/generated";

export const useRemoveMemberFromTeam = (teamId: number) => {
  const [removePerson, { loading }] = useRemovePersonFromTeamMutation({
    refetchQueries: [TeamDocument, PeopleDocument, DimensionsDocument],
  });

  const handleRemoveMemberFromTeam = async (personId: number) => {
    const result = await removePerson({ variables: { personId, teamId } });
    return result.data?.removePersonFromTeam;
  };

  return { handleRemoveMemberFromTeam, loading };
};
